import React, {
  useState,
  useEffect,
} from "react"

import "semantic-ui-css/semantic.min.css"

const Comment = ({
  selectedBankTransfer = {},
  selectedBankTransfer: {
    comment: commentText = '',
  } = {},
  onSubmitCommentPress = () => { },
  commentErrorMessage = '',
} = {}) => {
  const [inputComment, setInputComment] = useState('')

  useEffect(() => {
    setInputComment(commentText || '')
  }, [commentText])

  const onTextChange = ({
    target: {
      value: v = "",
    } = {},
  } = {}) => {
    setInputComment(v)
    onSubmitCommentPress({ comment: v, selectedBankTransfer })
  }

  return (
    <form className="ui comment form">
      <div className="field">
        <textarea
          value={inputComment}
          onChange={onTextChange}
          placeholder="Leave a comment..."
        />
      </div>
      {/*
      <button type="button" onClick={async () => onSubmitCommentPress({ comment: inputComment, selectedBankTransfer })} className="submit-comment-button ui labeled icon violet button">
        <i className="arrow up icon" />
        Submit
      </button>
      <br />
      <br />
*/}
      <span>{commentErrorMessage}</span>
    </form>

  )
}

export default Comment
